import { render, staticRenderFns } from "./PptITextAttr.vue?vue&type=template&id=23165076&"
import script from "./PptITextAttr.vue?vue&type=script&lang=js&"
export * from "./PptITextAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/PptITextAttr.vue"
export default component.exports